/**
=========================================================
* Soft UI Dashboard React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React Base Styles
import colors from "./../../base/colors";
import typography from "./../../base/typography";
import boxShadows from "./../../base/boxShadows";

// Soft UI Dashboard PRO React Helper Functions
import pxToRem from "./../../functions/pxToRem";

const { white, text, info, secondary, primary } = colors;
const { size } = typography;
const { buttonBoxShadow } = boxShadows;

export default {
    base: {
        backgroundColor: white.main,
        minHeight: pxToRem(40),
        color: text.main,
        boxShadow: buttonBoxShadow.main,
        padding: `${pxToRem(12)} ${pxToRem(24)}`,

        "&:hover": {
            backgroundColor: white.main,
            boxShadow: buttonBoxShadow.stateOf
        },

        "&:focus": {
            boxShadow: buttonBoxShadow.stateOf
        },

        "&:disabled": {
            boxShadow: buttonBoxShadow.main
        },

        "& .material-icon, .material-icons-round, svg": {
            fontSize: `${pxToRem(16)} !important`
        }
    },

    small: {
        minHeight: pxToRem(32),
        padding: `${pxToRem(8)} ${pxToRem(32)}`,
        fontSize: size.xs,

        "& .material-icon, .material-icons-round, svg": {
            fontSize: `${pxToRem(12)} !important`
        }
    },

    large: {
        minHeight: pxToRem(47),
        padding: `${pxToRem(14)} ${pxToRem(64)}`,
        fontSize: size.sm,

        "& .material-icon, .material-icons-round, svg": {
            fontSize: `${pxToRem(22)} !important`
        }
    },

    primary: {
        backgroundColor: primary.main,
        color: primary.contrastText,

        "&:hover": {
            backgroundColor: primary.main
        },

        "&:focus:not(:hover)": {
            backgroundColor: primary.focus,
            boxShadow: buttonBoxShadow.stateOfNotHover
        }
    },

    secondary: {
        backgroundColor: secondary.main,
        color: secondary.contrastText,
        "&:hover": {
            backgroundColor: secondary.main
        },

        "&:focus:not(:hover)": {
            backgroundColor: secondary.focus,
            boxShadow: buttonBoxShadow.stateOfNotHover
        }
    }
};
